import {
  Box,
  Button,
  DialogActions,
  DialogContentText,
  Divider,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import { Dispatch } from '@reduxjs/toolkit';
import { TableHeader } from 'components/TranslationProgress/TranslationProgress.styled';
import { ButtonVariantEnum } from 'enums/buttonVariant';
import { OrderEnum } from 'enums/orderEnum';
import React, { Component, Fragment } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { AppDispatch } from 'store';
import { dialogClose } from 'store/dialog/dialog.actions';
import { DialogOpenPayloadJob, DialogOpenPayloadJobs } from 'store/dialog/dialog.interface';
import { CustomDialogButtonContainer, CustomDialogContent, CustomDialogTableCell } from '../CustomDialog.styled';

interface IProps {
  onClose: ((response: ButtonVariantEnum) => void) | undefined;
  jobs: DialogOpenPayloadJobs;
  projectId: string;
  projectLanguages: Array<string>;
}

interface IDispatchProps {
  dialogClose: () => AppDispatch;
}

interface IState {
  order: OrderEnum;
}

type PropType = IProps & WithTranslation & IDispatchProps;

class NoSupportedElements extends Component<PropType, IState> {
  constructor(props: PropType) {
    super(props);

    this.state = {
      order: OrderEnum.ASC,
    };
  }

  sortItems = (a: DialogOpenPayloadJob, b: DialogOpenPayloadJob): number => {
    const { order } = this.state;
    const isAsc = order === OrderEnum.ASC;

    if (!a.name || !b.name) return 0;
    if (a.name < b.name) return isAsc ? -1 : 1;
    if (a.name > b.name) return isAsc ? 1 : -1;
    return 0;
  };

  handleChangeDirection = (): void => {
    const { order } = this.state;

    this.setState({ order: order === OrderEnum.ASC ? OrderEnum.DESC : OrderEnum.ASC });
  };

  handleIgnoreClick = (): void => {
    const { dialogClose } = this.props;

    dialogClose();
  };

  render(): JSX.Element {
    const { t, jobs } = this.props;
    const { order } = this.state;
    return (
      <Fragment>
        <CustomDialogContent>
          <DialogContentText>
            <Typography component="span" color="textPrimary">
              {t('modal.noSupportedElementsAction')}
            </Typography>
          </DialogContentText>
          <Box display="flex" maxHeight="260px" overflow="auto">
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <CustomDialogTableCell header="true">
                    <TableHeader sortable active sortDirection={order} onClick={this.handleChangeDirection}>
                      <Typography component="div" variant="body2" color="textPrimary">
                        <Box fontWeight="fontWeightBold" marginLeft="8px">
                          {t('modal.contentName')}
                        </Box>
                      </Typography>
                    </TableHeader>
                  </CustomDialogTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {jobs.sort(this.sortItems).map(({ name }, index) => {
                  return (
                    <TableRow key={index}>
                      <CustomDialogTableCell disableCursor="true">
                        <Box marginLeft="8px" padding="6px 0">
                          {name}
                        </Box>
                      </CustomDialogTableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Box>
        </CustomDialogContent>
        <Divider />
        <DialogActions>
          <CustomDialogButtonContainer>
            <Button variant="contained" color="secondary" onClick={this.handleIgnoreClick}>
              {t('modal.ok')}
            </Button>
          </CustomDialogButtonContainer>
        </DialogActions>
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AppDispatch>): IDispatchProps => ({
  dialogClose: (): AppDispatch => dispatch(dialogClose()),
});

export default connect(null, mapDispatchToProps)(withTranslation()(NoSupportedElements));
